export default "__VITE_ASSET__oZZNxixe__"